import { Pipe, PipeTransform } from "@angular/core";

import { ICountryContentStatus } from "../interfaces/icountrycontentstatus";

/**
 * Filters the items based toggle switch state and filter
 */
@Pipe({
    name: "countriesfilter",
    standalone: true
})
export class CountriesFilterPipe implements PipeTransform {
    transform(countries: ICountryContentStatus[], searchTerm: string): any {

        if (!searchTerm || searchTerm.length === 0) {
            return countries;
        }
        let st:string = searchTerm.toLowerCase();

        if (!countries) {
            return countries;
        }
        return countries.filter(
            (item: ICountryContentStatus) => {
                return item.country.code.toLowerCase().indexOf(st) > -1 ||
                    item.country.isoCode.toLowerCase().indexOf(st) > -1 ||
                    item.country.name.toLowerCase().indexOf(st) > -1;
            });
    }
}

